import axiosInstance from "../Common/Axios/axiosInstance";
import API from "../Common/Endpoint/serviceConstrants";

export const rewardWidgetConfigDataGetApi = async (payload) => {
    const { response = {} } = await axiosInstance.get(`${API.clientMasterConfigData}`, {
        params: {
            configKey: payload,
        },
        headers: {
            ...axiosInstance.defaults.headers,
            Encryption: 1,
        }
    },
    );
    return response;
};  
